import React from "react";
import Navbar from "../components/layout/Navbar";
import PlatformPageHero from "../components/platform/PlatformPageHero";
import BridgeSection from "../components/sections/home/BridgeSection";
import TwoProductsSection from "../components/sections/home/TwoProductsSection";

const PlatformOverviewPage = () => (
  <div className="min-h-screen bg-paper">
    <Navbar />
    <main className="pt-16">
      <PlatformPageHero
        eyebrow="Platform overview"
        title="From network signals to useful mobility insight"
        body="Telcofy provides the processing layer and the analytical workspace needed to turn aggregated network data into maps, measures and project outputs."
      />
      <BridgeSection />
      <TwoProductsSection />
    </main>
  </div>
);

export default PlatformOverviewPage;
